<template>
  <div id="wholesite">
    <router-link :to="{ path: '/' }" >
      <img id="logo" alt="Vue logo" src="./assets/logo.png">
    </router-link>
    
    <router-view ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  @import '../node_modules/material-design-lite/material.min.css';

body {
  background-image: './assets/background.png';
  background-repeat: repeat;
}

#logo {
  width: 90%;
  height: auto;
  margin: 0 5% 5% 5%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.status-message {
  font-size: 130%;
}
</style>
